export default "__VITE_ASSET__COc$azh8__"